import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsLoggedIn, useSetIsLoggedIn } from '../../state';
import fetchWithToken, { checkAuthStatus } from '../../services';

const CheckAuthStatus = () => {
    const isLoggedIn = useIsLoggedIn();
    const setIsLoggedIn = useSetIsLoggedIn();
    const navigate = useNavigate();

    useEffect(() => {
        // const checkAuthStatus = async () => {
        //     try {
        //         const response = await fetchWithToken('/check-auth-status', {
        //             method: 'POST'
        //         });
        //         const data = await response.json();
        //         console.log('Data retrieved from check-auth-status:', data)

        //         if (data.authStatus === true) {
        //             setIsLoggedIn(true);
        //         } else {
        //             console.log('User not logged in');
        //             setIsLoggedIn(false);
        //         }
        //     } catch (error) {
        //         console.error('Error checking if user is logged in:', error);
        //         setIsLoggedIn(false);
        //     }
        // };

        checkAuthStatus();
    }, []);

    useEffect(() => {
        if (isLoggedIn !== null) {
            navigate('/');
        }
    }, [isLoggedIn]);

    return null;
};

export default CheckAuthStatus;
